import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {SortDirection} from '@mui/material'

import {RcfaComplianceTableData} from '../types'

export const complianceScoreColor = (value: number, maxValue: number): string => {
  if (maxValue === 0) {
    return customThemeConstants().palette.disabledBackgroundColor
  }

  const percentage = toPercent(value, maxValue)

  if (percentage >= 85) {
    return 'primary.main'
  }

  if (percentage >= 50) {
    return 'warning.main'
  }

  return 'error.main'
}

export function getComplianceScorePercentage(value: number, maxValue: number): number {
  return Number(toPercent(value, maxValue).toFixed(0))
}

function toPercent(a: number, b: number): number {
  if (b === 0) {
    return 0
  }

  return (a / b) * 100
}

export const sortPlantsByComplianceScoreBar = (
  plantListData: RcfaComplianceTableData[],
  sortDir: SortDirection
) => {
  return plantListData.sort((a, b) => {
    if (a.rcfaCompliance?.totalMandatoryCount === 0) {
      return 1
    }
    if (b.rcfaCompliance?.totalMandatoryCount === 0) {
      return -1
    }

    const aScore = getComplianceScorePercentage(
      a.rcfaCompliance?.completedCount ?? 0,
      a.rcfaCompliance?.totalMandatoryCount ?? 0
    )
    const bScore = getComplianceScorePercentage(
      b.rcfaCompliance?.completedCount ?? 0,
      b.rcfaCompliance?.totalMandatoryCount ?? 0
    )

    return sortDir === 'asc' ? aScore - bScore : bScore - aScore
  })
}
